<ng-container *ngIf="state$ | async as state">
  <div
    class="global-loader-backdrop"
    [class.active]="state.active"
  >
    <div class="global-loader-box" *ngIf="state.active">
      <div class="spinner"></div>

      <div class="loader-text" *ngIf="state.text">
        {{ state.translate ? (state.text | translate) : state.text }}
      </div>
    </div>
  </div>
</ng-container>
